import '@ionic/core';
import { setupConfig } from '@ionic/core';

/**
 * The code to be executed should be placed within a default function that is
 * exported by the global script. Ensure all of the code in the global script
 * is wrapped in the function() that is exported.
 */
export default async () => {
  globalThis.ccCouchdbUrl = 'https://ch.concourse.tools'
  globalThis.ccLambdaBaseUrl = 'https://app.concourse.tools'
  globalThis.ccMPXJBaseUrl = 'https://app.concourse.tools'
  globalThis.ccFrontEndUrl = 'https://app.concourse.tools'
  globalThis.msClientId = 'b8e1fa75-1a87-4b8f-bf72-debb144b2d4b'
  setupConfig({
    mode: 'md'
  });
};
